import { ClientType } from '~/ApiClient';
export var NotificationEmailHtmlBodyError;
(function (NotificationEmailHtmlBodyError) {
})(NotificationEmailHtmlBodyError || (NotificationEmailHtmlBodyError = {}));
var NotificationEmailHtmlBodyRequest = /** @class */ (function () {
    function NotificationEmailHtmlBodyRequest(notificationId, emailNotificationId) {
        this.api = ClientType.pigeon;
        this.knownErrorCodes = Object.values(NotificationEmailHtmlBodyError);
        this.path = "notifications/".concat(notificationId, "/emails/").concat(emailNotificationId, "/body/html");
    }
    return NotificationEmailHtmlBodyRequest;
}());
export { NotificationEmailHtmlBodyRequest };
